module.exports = __webpack_public_path__ + "static/media/love-tarot.b315792c.png";


//////////////////
// WEBPACK FOOTER
// ./src/mobioastro/assets/images/love-tarot.png
// module id = 1340
// module chunks = 0